const KEYS = {
  AUTH: "auth",
  ACCESS_TOKEN: "auth_access_token",
  REFRESH_TOKEN: "auth_refresh_token",
  PROFILE: "profile",
};

const cookie = {
  set: (name, value) => {
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; SameSite=Strict`;
  },
  get: (name) => {
    const match = document.cookie.split("; ").find((row) => row.startsWith(`${name}=`));
    return match ? decodeURIComponent(match.split("=")[1]) : null;
  },
  remove: (name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  },
};

export const authStorage = {

  save: ({ token, refreshtoken, ...rest }) => {
    // localStorage.setItem(KEYS.ACCESS_TOKEN,  token);
    // // localStorage.setItem(KEYS.REFRESH_TOKEN, refreshtoken);
    // localStorage.setItem(KEYS.AUTH, JSON.stringify({ token, refreshtoken, ...rest }));

    // store a auth token
    cookie.set(KEYS.ACCESS_TOKEN, token);
    // cookie.set(KEYS.REFRESH_TOKEN, refreshtoken);
    
    // store a auth in cookie
    // cookie.set(KEYS.AUTH, JSON.stringify({ token, refreshtoken, ...rest }));
    
  },

  updateTokens: (accessToken, refreshToken) => {
    // localStorage.setItem(KEYS.ACCESS_TOKEN,  accessToken);
    // localStorage.setItem(KEYS.REFRESH_TOKEN, refreshToken);

    cookie.set(KEYS.ACCESS_TOKEN, accessToken);
    cookie.set(KEYS.REFRESH_TOKEN, refreshToken);

    const existing = authStorage.getAuth() || {};

    // localStorage.setItem(KEYS.AUTH, JSON.stringify({ ...existing, token: accessToken, refreshtoken: refreshToken, }));

    cookie.set(KEYS.AUTH, JSON.stringify({ ...existing, token: accessToken, refreshtoken: refreshToken, }));
  },

  // getAccessToken: () => localStorage.getItem(KEYS.ACCESS_TOKEN),

  // getRefreshToken: () => localStorage.getItem(KEYS.REFRESH_TOKEN),

  // getAuth: () => JSON.parse(localStorage.getItem(KEYS.AUTH) || "null"),

  // clear: () => Object.values(KEYS).forEach((k) => localStorage.removeItem(k)),

  getAccessToken: () => cookie.get(KEYS.ACCESS_TOKEN),

  getRefreshToken: () => cookie.get(KEYS.REFRESH_TOKEN),

  getAuth: () => {
    const val = cookie.get(KEYS.AUTH);
    return val ? JSON.parse(val) : null;
  },

  saveProfile: (profileData) => {
    cookie.set(KEYS.PROFILE, JSON.stringify(profileData));
  },

  getProfile: () => {
    const val = cookie.get(KEYS.PROFILE);
    return val ? JSON.parse(val) : null;
  },

  getUser: () => {
    return authStorage.getProfile() || authStorage.getAuth();
  },

  clear: () => Object.values(KEYS).forEach((k) => cookie.remove(k)),
};